import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import cardsList from '../lib/agent-kit/cards-list';
import { H1, Image, Modal as BaseModal } from '.';
import Chevron from '../assets/images/chevron-white.svg';
import { colors } from '../utils';

const BackArrow = styled.div`
  display: flex;
  height: 100%;
  left: -44px;
  position: absolute;
  align-items: center;
  transform: rotate(180deg);
`;

const ForwardArrow = styled.div`
  display: flex;
  height: 100%;
  right: -44px;
  position: absolute;
  align-items: center;
`;

const Modal = styled(BaseModal)`
  height: 416px;
`;

const ModalContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 615px;
  padding: 40px 4px;
`;

const Title = styled(H1)`
  margin: 8px 0 24px 0;
  color: ${colors.g04};
  font-size: 24px;
  font-weight: bold;
`;

const LinkButton = styled.button.attrs({
  type: 'button'
})`
  align-items: center;
  background: #00000038;
  border: 0 none;
  border-radius: 4px;
  color: ${colors.w01}
  height: 40px;
  outline: none;
  padding: 0;
  cursor: pointer;
  transition: all .15s ease;

  &:hover {
    background: #0000009c
  }
`;

const Content = styled.div`
  padding: 0 56px;
  max-height: 215px;
  overflow-y: scroll;
`;

function KitCarousel({ isVisible, activeItem, setActiveItem, setIsVisible }) {
  if (!isVisible) {
    return null;
  }

  const rotateCarousel = index => {
    if (index < 0) {
      setActiveItem(cardsList.length - 1);
      return;
    }
    if (index > cardsList.length - 1) {
      setActiveItem(0);
      return;
    }
    setActiveItem(index);
  };

  const card = cardsList[activeItem];
  return (
    <Modal toggleModal={() => setIsVisible(false)}>
      <BackArrow>
        <LinkButton position="left" type="button" onClick={() => rotateCarousel(activeItem - 1)}>
          <Image width="40px" height="40px" src={Chevron} />
        </LinkButton>
      </BackArrow>

      <ForwardArrow>
        <LinkButton position="right" type="button" onClick={() => rotateCarousel(activeItem + 1)}>
          <Image width="40px" height="40px" src={Chevron} />
        </LinkButton>
      </ForwardArrow>

      <ModalContent>
        <Image width="88px" height="88px" src={card.icon} />

        <Title>{card.title}</Title>

        <Content>{card.description}</Content>
      </ModalContent>
    </Modal>
  );
}

KitCarousel.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  activeItem: PropTypes.number,
  setActiveItem: PropTypes.func.isRequired,
  setIsVisible: PropTypes.func.isRequired
};

KitCarousel.defaultProps = {
  activeItem: null
};

export default KitCarousel;
